import { render, staticRenderFns } from "./RenderImage.vue?vue&type=template&id=25aa5f44&scoped=true"
import script from "./RenderImage.vue?vue&type=script&lang=ts"
export * from "./RenderImage.vue?vue&type=script&lang=ts"
import style0 from "./RenderImage.vue?vue&type=style&index=0&id=25aa5f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aa5f44",
  null
  
)

export default component.exports